import { render, staticRenderFns } from "./SimManagementNew.vue?vue&type=template&id=9b3654b2&scoped=true&"
import script from "./SimManagementNew.vue?vue&type=script&lang=js&"
export * from "./SimManagementNew.vue?vue&type=script&lang=js&"
import style0 from "./SimManagementNew.vue?vue&type=style&index=0&id=9b3654b2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b3654b2",
  null
  
)

export default component.exports